import { z } from "zod";
import { stripSearchParams, type SearchMiddleware } from "@tanstack/react-router";
import { defaultPageSearch, optionalPage, optionalSearch } from "./shared";

const customerSortSchema = z.enum(["createdAt:asc", "createdAt:desc"]);

export const customersSearchDefaults = {
  ...defaultPageSearch,
  sort: "createdAt:desc" as const,
};

export const customersSearchSchema = z.object({
  sort: optionalSearch(customerSortSchema),
  page: optionalPage,
});

export type CustomersSearch = z.infer<typeof customersSearchSchema>;

export const customersSearchMiddlewares: SearchMiddleware<CustomersSearch>[] = [
  stripSearchParams(customersSearchDefaults) as SearchMiddleware<CustomersSearch>,
];
